import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";
import { KOREA } from "utils/constant/ITME_INFO";
import InterestStar from "../../components/InterestStar";
import { useHighTotalScoreStockList } from "utils/clientAPIs/detailDiagnosis";
import Img from "components/common/List/img";
import Text from "components/common/List/Text";
import { useEffect, useState } from "react";
import DividerButton from "components/common/divider/button";
import { HighTotalScoreSkeleton } from "components/skeleton/KB";
import { trackPageAction } from "lib/analytics/core/actions";
import { TrackedList, TrackedListItem } from "lib/analytics/react/list";
import { ERROR_LOGO_URL, getPublicAssetUrl } from "utils/objectStorage";

function HighTotalScoreStocks() {
  const router = useRouter();
  const { t } = useTranslation("main");
  const [data, loading, error] = useHighTotalScoreStockList({ limit: 9 });
  const [page, setPage] = useState(0);
  const [sliceData, setSliceData] = useState<any>([]);
  useEffect(() => {
    if (data) {
      setSliceData(data.slice(0, 3));
    }
  }, [data]);
  const handleNext = () => {
    trackPageAction("more_kb_high_stocks_more");
    if (data) {
      if (page < 2) {
        setPage(page + 1);
        setSliceData(data.slice((page + 1) * 3, (page + 2) * 3));
      } else {
        setPage(0);
        setSliceData(data.slice(0, 3));
      }
    }
  };

  const ListTemp = ({ asset }: { asset: any }) => {
    return (
      <TrackedListItem
        itemData={{
          kind: "stock",
          ticker: asset.ITEM_CD_DL,
          market: asset?.LOC === KOREA ? "kr" : "us",
        }}
        href={`/detail/${asset.ITEM_CD_DL}`}
        className={` w-full flex items-center  px-6 py-2  gap-3 bg-white `}
        // onClick={() => router.push(`/detail/${asset.ITEM_CD_DL}`)}
        data-gtm-id={`kb-high-stocks-list`}
      >
        <Img
          src={
            getPublicAssetUrl(`logos/${asset.ITEM_CD_DL}.png`) ||
            ERROR_LOGO_URL
          }
          HR_ITEM_NM={""}
        />

        <div
          className={`justify-start grow  overflow-hidden whitespace-pre-wrap flex-col  items-start inline-flex `}
        >
          <Text
            item={
              router.locale === "ko"
                ? asset.ITEM_KR_NM && asset.ITEM_KR_NM
                : asset.ITEM_ENG_NM && asset.ITEM_ENG_NM
            }
            price={
              router.locale === "ko"
                ? asset.ADJ_CLOSE_KRW &&
                  asset.ADJ_CLOSE_KRW.toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }) + (asset.CAT !== "Index" ? "원" : "")
                : asset.ADJ_CLOSE &&
                  asset.ADJ_CLOSE.toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }) +
                    (asset.CAT !== "Index"
                      ? asset?.LOC === KOREA
                        ? "₩"
                        : "$"
                      : "")
            }
            percent={asset.ADJ_CLOSE_CHG.toLocaleString("en-us", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })}
          />
        </div>

        <div className="flex items-center shrink-0 justify-end">
          <div>
            {
              <InterestStar
                asset={asset}
                size={30}
                triggerSectionId="kb_attractive_stocks"
              />
            }
          </div>
        </div>
      </TrackedListItem>
    );
  };

  //
  if (loading || error || sliceData?.length === 0)
    return (
      <div className="w-full">
        <HighTotalScoreSkeleton />
      </div>
    );
  return (
    <div className="flex flex-col w-full gap-2">
      <div className="px-6 pt-6">
        <span className={`${TYPO.TYPO4_SB} text-gray80`}>
          {t("highAttractivenessStocks")}
        </span>
      </div>
      <TrackedList listId="kb_attractive_stocks" totalCount={sliceData?.length}>
        <div className="py-2 flex flex-col gap-2">
          {sliceData?.map((asset: any, index: number) => {
            return <ListTemp asset={asset} key={index} />;
          })}
        </div>
      </TrackedList>

      <DividerButton
        text={t("viewMorePage", { page: page + 1, total: 3 })}
        onClick={handleNext}
        data-gtm-id={`kb-high-stocks-more-button`}
      />
    </div>
  );
}

export default HighTotalScoreStocks;
